import axios from "axios";

const api_url = process.env.VUE_APP_APIURL;

const state = () => ({
  status: "",
  token: "",
  url: api_url,
});

const getters = {
  isLoggedIn: (state) => !!state.token,
  authStatus: (state) => state.status,
  token: (state) => state.token,
};

const mutations = {
  auth_request(state) {
    state.status = "loading";
  },
  auth_success(state, payload) {
    state.token = payload.token;
    state.status = "success";
  },
  auth_error(state) {
    state.status = "error";
  },
  logout_clear(state) {
    state.status = "";
    state.token = "";
  },
};

const actions = {
  login({ commit }) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      axios({
        url: "/.netlify/functions/auth_login",
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
      })
        .then((resp) => {
          const token = resp.data.token;
          commit("auth_success", {
            token: token,
          });
          resolve(resp);
        })
        .catch((err) => {
          if (err.statusCode == 401) {
            commit("auth_error");
            commit("logout_clear");
            resolve(err);
          } else {
            commit("auth_error");
            commit("logout_clear");
            reject(err);
          }
        });
    });
  },

  logout({ commit }) {
    return new Promise((resolve /*reject*/) => {
      commit("logout_clear");
      resolve();
    });
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
